import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, IconButton, Typography } from '@mui/material';
import Modal from '@mui/material/Modal';
import React from 'react';
import './styles.css';
import { sxButtonScheduleAction, sxCloseIconButton, sxTypographySubTitleModal, sxTypographyTitleModal } from './sxProps';

const ModalCameraAccess: React.FC<{ showModal: boolean; handleShowModal: () => void; handleAllowCamera: (value: boolean) => void }> = ({ handleAllowCamera, showModal, handleShowModal }) => {

    const allowCameraAccess = (allow: boolean) => {
        handleAllowCamera(allow);
        handleShowModal();
    }

    return (
        <div>
            <Modal
                open={showModal}
                onClose={handleShowModal}
            >
                <div className='container-camera-access-modal' >
                    <IconButton
                        aria-label="Fechar"
                        onClick={handleShowModal}
                        sx={sxCloseIconButton}
                    >
                        <FontAwesomeIcon icon={faTimes} size="1x" color='black' />
                    </IconButton>
                    <div>
                        <Typography sx={sxTypographyTitleModal}>Permissão para acessar a câmera</Typography>
                        <Typography sx={sxTypographySubTitleModal}>Autorize o acesso à câmera do seu dispositivo para continuar.</Typography>
                    </div>
                    <div className='schedule-modal-buttons-holder'>
                        <Button onClick={() => allowCameraAccess(false)} variant='outlined' sx={sxButtonScheduleAction}>
                            <Typography>Não permitir</Typography>
                        </Button>
                        <Button onClick={() => allowCameraAccess(true)} variant='contained' sx={sxButtonScheduleAction}>
                            <Typography>Permitir</Typography>
                        </Button>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default ModalCameraAccess;
